<template>
  <component
      v-if="visible"
      :is="componentOfPart(selectedPart)"
      :part="partRef(selectedPart)"
      :data="localData"
      :readonly="ro"
      :viewmode="vm"></component>
</template>

<script setup lang="ts">
import useContainer, { type ContainerProps, containerProps } from "./Container";
import {defineProps, computed} from "vue";
import {injectEnv} from "../Environment";
import type {Touch} from "@t/fd/layout/Touch";

const untypedProps = defineProps({
  ...containerProps,
});
const props = untypedProps as ContainerProps;

const part = computed<Touch>(() => props.part as Touch);
const { componentOfPart, partRef, localData, ro, vm, visible } = useContainer(props);
const env = injectEnv();

const selectedPart = computed(() => {
  return env.touch ? part.value.touch : part.value.mouse;
});
</script>
